import { render, staticRenderFns } from "./schment.vue?vue&type=template&id=94a7b0be&scoped=true&"
import script from "./schment.vue?vue&type=script&lang=js&"
export * from "./schment.vue?vue&type=script&lang=js&"
import style0 from "./schment.vue?vue&type=style&index=0&id=94a7b0be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a7b0be",
  null
  
)

export default component.exports